import AppRoutes from './app/routes';

export function App() {
  return <AppRoutes />;
}
